import { generateLabelSlug } from "./Labels";

/*
 * Create the HTML for the legend, with color-coded boxes.
 * @author Aaron Hodge Silver
 */

export const renderLegend = () => {

	let calLegend = "";
	let calStyle = "";
	let legendLabels = [];

	// Ticket Amount-based labels
	if (limelight.data.ticket_based_labels) {
		limelight.data.ticket_based_labels.filter((item) => {
			legendLabels.push(item);
			return;
		});
	}
	// Manually-managed labels
	if (limelight.data.labels) {
		limelight.data.labels.filter((item) => {
			if (item.display_legend != "never") {
				legendLabels.push(item);
				return;
			}
			return;
		});
	}

	if (legendLabels.length > 0) {
		calLegend +=
			'<section class="calendar__legend" aria-label="Labels legend">';
		calStyle += '<style type="text/css">';
		legendLabels.forEach((label) => {
			var hex = label.label_color.toLowerCase().slice(1);
			var slug = generateLabelSlug(label);
			calLegend +=
				'<div class="calendar__legend-each calendar__legend-each-' +
				slug +
				'">';
			calLegend +=
				'<div class="calendar__legend-color calendar__legend-color--' +
				slug +
				'"></div>';
			calLegend +=
				'<div class="calendar__legend-text"><div>' +
				label.label_title +
				"</div></div>";
			calLegend += "</div>";
			calStyle +=
				".rpm-calendar .calendar__legend-color--" +
				slug +
				"::before { background-color: #" +
				hex +
				"; }";
			calStyle +=
				"a.event-time.event-time--" +
				slug +
				" { color: #" +
				hex +
				"; }";
		});
		calLegend += "</section>";
		calStyle += "</style>";
	}

	return calLegend + calStyle;
}
